import { StringDecoder } from 'string_decoder';
import { AsYouType } from 'libphonenumber-js/min';

export enum QuestionType {
    Text = 1,
    Date,
    Number,
    Secure,
    Boolean,
    Password
}

export class Question {
    constructor() { }
    name: string;
    comparer : string;
    questionOrder: number;
    questionText: string;
    answer: any;
    validationMessage: string;
    questionType: QuestionType;
    propertyMapping: string;
    canFailValidation: boolean;
    parentPropertyName : string;
    digits: number;
    
    public get questionTypeString() : string {
        return QuestionType[this.questionType].toLowerCase();
    }
    
    validate(): boolean {
        if (this.answer == undefined && !this.answer) {
            this.validationMessage = `We need your ${this.name} to complete the application process.`;
            return false;
        }
        return true;
    }

    set(value: any): boolean {
        console.log('worked')
        //we need a custom case here of ecAllowed --
        if(value.name = "ecAllowed" && value.value != undefined) {
            this.answer = value.value;
            return true;
        }
        if (!value.value) {
            this.validationMessage = "We really need that though...";
            return false;
        }
        this.answer = value.value;
        return true;
    }

    format(val : string):string{ return val;};
}

export class NumberQuestion extends Question {
    constructor() {
        super();
        this.questionType = QuestionType.Number
    }
    warned : boolean = false;
    errorOnQuestion : boolean = false;
    validate(): boolean {
        // base does a null check.
        if(!super.validate() && !(this.name == 'Fax' || this.name == 'MobilePhone')){ return false;}
        //fax and mobile CAN be null, but PhoneNumber is REQUIRED here
        var phoneRegex = new RegExp(/^[0-9]{10}$/);
        //phone validation rules:
        //cannot all be the same digit, and cannot be consecutive, i.e. 123-456-7890
        if(this.name == 'PhoneNumber' || this.name == 'Fax' || this.name == 'MobilePhone') {
            //strip out the formatting
            if((this.name == 'Fax' || this.name == 'MobilePhone') && !this.answer) return true;
            let ans = this.answer.replace(/\D+/g, '');
            if(ans == "0000000000" 
            || ans == "1111111111" 
            || ans == "2222222222" 
            || ans == "3333333333" 
            || ans == "4444444444" 
            || ans == "5555555555" 
            || ans == "6666666666" 
            || ans == "7777777777" 
            || ans == "8888888888" 
            || ans == "9999999999" 
            || ans.includes("2345678")) {
                this.validationMessage = "Please provide a valid phone number.";
                return false;
            }else{return true;}

        }
        // else if(this.name == 'Fax' || this.name == 'MobilePhone') {
        //     if(!this.answer) return true;
        //     if(this.digits && !phoneRegex.test(this.answer.replace(/-/g,'').toString())) {
        //         this.validationMessage = `Please provide a ten digit phone number, i.e. 555-555-5555. If you do not have 
        //             ${this.name == 'Fax' ? 'fax' : 'mobile phone' } number, enter nothing and press continue.`
        //         return false;
        //     }
        // }
        // else {
            if (this.digits && this.answer.toString().length != this.digits) {
                this.validationMessage = `Your ${this.name} has ${this.answer.toString().length} digits, please enter a ${this.digits} digit ${this.name}.`
                return false;
            };
        // }

        if(this.name == 'Income') {
            if(this.answer > 50000 && !this.warned) {
                this.validationMessage = 'We are requesting your gross monthly income. Please confirm the amount entered is correct.';
                this.warned = true;
                return false;
            } else if(this.answer < 0) {
                this.validationMessage = 'Please enter a positive number for your monthly income';
                return false;
            } else {
                this.warned = false;
                return true;
            }
        }
        return true;
    }

    format = (val : string) : string => {
        
        // if(this.name == "MobilePhone" || this.name == "PhoneNumber" || this.name == "Fax"){
        //     const phoneNumber = new AsYouType('US').input(val);
        //     // const phoneNumber = parsePhoneNumber(val + '', 'US' as CountryCode);
        //     return phoneNumber;//.formatNational();
        // };
        return val;
    }
}

export class TextQuestion extends Question {

    constructor() {
        super();
        this.questionType = QuestionType.Text
    }

    canSkipWithToggle : boolean = false;
    //this is for mobile layout to set validationMessage
    errorOnQuestion : boolean = false;
   
    format = (val : string): string =>{
        val = val.replace(/-/g,'')
        if(this.name == 'SSN'){
            let len = val.length
            if (len < 4)
                return val
            else if (len  >3 && len < 6)
                this.answer = `${val.substr(0, 3)}-${val.substr(3)}`
            else if (len > 5)
            {
                this.answer = `${val.substr(0, 3)}-${val.substr(3, 2)}-${val.substr(5, 4)}`
            }
                    
        }
        if(this.name == 'MiddleName' && this.answer) {
            this.canSkipWithToggle = false;
        }
        return this.answer;        
      }

      validate(): boolean {
        // base does a null check.
        //put in override for middle name and its checkbox...
        if(!super.validate() && !(this.name == 'MiddleName')){ return false;}

        let sSNRegex = new RegExp(/^[0-9]{9}$/);
        let nameRegex = new RegExp(/^[a-zA-Z\-\ ]*$/);
        if (this.name == 'SSN') {
            //do a regex test to see if the ssn input has any alpha chars
            if(!sSNRegex.test(this.answer.replace(/-/g,'').toString())) {
                this.validationMessage = "Your SSN must be 9 digits and only contain only numbers.";
                return false;
            } 
            // else if(this.digits && this.answer.replace(/-/g,'').toString().length != this.digits) {
            //     this.validationMessage = `Please enter a ${this.digits} digit ${this.name}.`
            //     return false;
            // }
        };

        //allow the user to skip the middle name question if they have set the toggle and have not added any value
        if(this.name == 'MiddleName') {
            console.log('middle name answer', this.answer);
            if((this.answer == undefined || this.answer == '') && this.canSkipWithToggle) {
                return true;
            } else if (!this.canSkipWithToggle && (this.answer == undefined || this.answer == '')) {
                return false;
            }
        }

        //check each of the name inputs for validity using our name regex
        if(this.name == 'FirstName' || this.name == 'LastName' || this.name == 'MiddleName') {
            if(!nameRegex.test(this.answer)) {
                this.validationMessage = `${this.name} must contain A-Z, hyphens, and spaces only.`
                return false;
            }
        }

        if(this.name == 'Password'){
            this.validationMessage = "";
            // tODO : make sure the strength requirements are met.
            let lowercaseCheck = new RegExp("(?=.*[a-z])");
            let upperCaseCheck = new RegExp("(?=.*[A-Z])");
            let numericCheck = new RegExp("(?=.*[0-9])");
            let specialCharacterCheck = new RegExp("(?=.[!@#\$%\^&])");
            let lengthCheck = new RegExp("(?=.{8,})");
            if(!lowercaseCheck.test(this.answer)){
                this.validationMessage += "Your password must contain at least one lower case letter. ";
            }
            if(!upperCaseCheck.test(this.answer)){
                this.validationMessage += "Your password must contain at least one upper case letter. ";
            }
            if(!numericCheck.test(this.answer)){
                this.validationMessage += "Your password must contain at least one number. ";
            }
            if(!specialCharacterCheck.test(this.answer)){
                this.validationMessage += "Your password must contain at least one special character. ex: !@#$%^&*() ";
            }
            if(!lengthCheck.test(this.answer)){
                this.validationMessage += "Your password must be atleast 8 characters. ";
            }

            if(this.validationMessage) return false;
        }

        

        if(this.name == "PasswordVerify"){
            if(this.answer != this.comparer){
                this.validationMessage = "Your passwords do not match.";
                return false;
            }
        }
        return true;
    }
}

export class DateQuestion extends Question {
    constructor() {
        super();
        this.questionType = QuestionType.Date
    }
    validate() : boolean {
        if(!super.validate()) {return false;}
        if(this.name == 'DOB') {
            let today = new Date();
            let comparerDate = new Date(this.answer);
            comparerDate.setDate(comparerDate.getDate()+1);
            comparerDate.setHours(0);
            comparerDate.setMinutes(0);
            comparerDate.setMilliseconds(0);
            let comparer2Date = new Date(today.getFullYear(), today.getMonth(), today.getDate())
            if((comparerDate.toDateString() == comparer2Date.toDateString())) {
                this.validationMessage = "You entered today's date. Please provide your birthday."
                return false;
            }
            if((comparerDate.getFullYear() < comparer2Date.getFullYear()-100)) {
                this.validationMessage = "Please provide a valid birthday."
                return false;
            }
            if((comparerDate > comparer2Date)) {
                this.validationMessage = "Please provide a valid birthday."
                return false;
            }
        }
        return true;
    }
}

export class BooleanQuestion extends Question {
    constructor() {
        super();
        this.questionType = QuestionType.Boolean
    }

    set(value: any): boolean {
        console.log('worked')
        if (value.value == undefined) {
            this.validationMessage = "We really need that though...";
            return false;
        }
        this.answer = value.value;
        return true;
    }
}